import {Pipe, PipeTransform} from '@angular/core';
import {UtilService} from '../util/util.service';
import {NameServerVO, PolicyUserVO, RdapServerVO, TrustAnchorVO} from '../generate/TopLevelDomainVO';
import {ChangeVO} from '../generate/ChangeVO';

@Pipe({
  name: 'defineDomainViewCss'
})
export class DefineDomainViewCssPipe implements PipeTransform {

  constructor(public utilService: UtilService) {
  }


  transform(change: ChangeVO, field: any, section: string): string {
    switch (section) {
      case 'contact':
        return this.transformContact(change, field);
      case 'metadata':
        return this.transformMetadata(change, field);
      case 'trustAnchor':
        return this.transformTrustAnchor(change, field);
      case 'nameServer':
        return this.transformNameServer(change, field);
      case 'registry':
        return this.transformRegistry(change);
      case 'whois':
        return this.transformWhois(change);
      case 'rdap':
        return this.transformRdap(change, field);
      case 'policy':
        return this.transformAuthPolicy_policy(change, field);
      case 'authUsers':
        return this.transformAuthPolicy_users(change, field);
    }
  }

  transformSingleField(change: ChangeVO) {
    let css: string = "break-word";
    if (change == null) {
      return css;
    }
    return css + " " + this.utilService.defineCSS(change.operationType);
  }

  transformRegistry(change: ChangeVO): string {
    return this.transformSingleField(change);
  }

  transformWhois(change: ChangeVO): string {
    return this.transformSingleField(change);
  }


  private transformAuthPolicy_policy(change: ChangeVO, field: any) {
    const fieldChange: ChangeVO = this.utilService.getChange(field, change);
    return this.transformSingleField(fieldChange);
  }


  private transformContact(change: ChangeVO, field: string): string {
    const fieldChange: ChangeVO = this.utilService.getContactFieldChange(field, change);
    return this.transformSingleField(fieldChange);
  }

  private transformMetadata(change: ChangeVO, field: string): string {
    const fieldChange: ChangeVO = this.utilService.getChange(field, change);
    return this.transformSingleField(fieldChange);
  }

  transformNameServer(nsChange: ChangeVO, nameServer: NameServerVO): string {
    let css: string = "break-word";

    if (nsChange == null) {
      return css;
    }
    for (let change of nsChange.changes) {
      if (change.field === nameServer.hostname) {
        return this.transformSingleField(change);
      }
    }

    return css;
  }

  private transformAuthPolicy_users(authPolicyUsersChange: ChangeVO, policyUserVO: PolicyUserVO) {
    if (authPolicyUsersChange == null) {
      return '';
    }
    for (let change of authPolicyUsersChange.changes) {
      if (change.field === policyUserVO.id) {
        return this.transformSingleField(change);
      }
    }

    return '';
  }
  private transformTrustAnchor(trustAnchorChange: ChangeVO, trustAnchor: TrustAnchorVO) {
    let css: string = "break-word";

    if (trustAnchorChange == null) {
      return css;
    }
    for (let change of trustAnchorChange.changes) {
      let changedTrustAnchor: TrustAnchorVO;
      if (change.operationType === "ADD") {
        changedTrustAnchor = <TrustAnchorVO>change.newVal;
      } else {
        changedTrustAnchor = <TrustAnchorVO>change.oldVal;
      }

      if (JSON.stringify(changedTrustAnchor) === JSON.stringify(trustAnchor)) {
        return this.transformSingleField(change);
      }
    }

    return css;
  }

  transformRdap(change: ChangeVO, rdap: RdapServerVO) {
    let css: string = "break-word";
    if (change == null) {
      return css;
    }
    for (let rdapChange of change.changes) {
      if (rdapChange.field === rdap.url) {
        return this.transformSingleField(rdapChange);
      }
    }

    return css;
  }

}
